import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bigNum',
  standalone: false,
})
export class BigNumPipe implements PipeTransform {
  public transform(num: string | number): string {
    const n = typeof num === 'string' ? Number.parseFloat(num) : num;

    const k = 1000;
    const m = Math.pow(10, 6);
    const b = Math.pow(10, 9);

    if (n < k) return n.toFixed(0);
    if (n >= k && n < m) return (n / k).toFixed(1).replace('.0', '') + 'K';
    if (n >= m && n < b) return (n / m).toFixed(1).replace('.0', '') + 'M';
    return (n / b).toFixed(1).replace('.0', '') + 'B';
  }
}
